import { NavLink } from 'react-router-dom'
import { useDroppable } from '@dnd-kit/core'
import { Folder } from '../../types/folder'
import styles from '../common/Sidebar/Sidebar.module.css'

interface FolderNavLinkProps {
  folder: Folder
  onContextMenu?: (e: React.MouseEvent, folder: Folder) => void
}

export function FolderNavLink({ folder, onContextMenu }: FolderNavLinkProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: `folder-${folder.id}`,
    data: { folder },
  })

  return (
    <NavLink
      ref={setNodeRef}
      to={`/folders/${folder.id}`}
      onContextMenu={(e) => onContextMenu?.(e, folder)}
      className={({ isActive }) =>
        `${styles.navItem} ${isActive ? styles.active : ''} ${isOver ? styles.dropTarget : ''}`
      }
    >
      <i className="bi bi-folder" style={{ color: folder.color }}></i>
      <span className={styles.folderName}>{folder.name}</span>
      {folder.release_count !== undefined && folder.release_count > 0 && (
        <span className={styles.folderBadge}>{folder.release_count}</span>
      )}
    </NavLink>
  )
}
